const sh =
  "bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse";

const AiSummaryShimmer = () => (
  <div className="flex flex-col">
    <div className="flex flex-col gap-2 px-3 pt-3">
      <div className="flex items-center gap-1">
        <div className={`w-3.5 h-3.5 shrink-0 ${sh}`} />
        <div className={`h-[14px] w-[80px] ${sh}`} />
      </div>
      <div className={`h-3 w-[180px] ${sh}`} />
    </div>

    <div className="flex flex-col gap-[6px] py-3 mt-2 border-b border-border-gray dark:border-border-gray-dk mx-3">
      <div className={`h-[14px] w-full ${sh}`} />
      <div className={`h-[14px] w-[92%] ${sh}`} />
      <div className={`h-[14px] w-[85%] ${sh}`} />
      <div className={`h-[14px] w-[70%] ${sh}`} />
      <div className={`h-[14px] w-[55%] ${sh}`} />
    </div>
  </div>
);

export default AiSummaryShimmer;
